import { render, staticRenderFns } from "./DesignReview.vue?vue&type=template&id=4d4c00b9&"
import script from "./DesignReview.vue?vue&type=script&lang=js&"
export * from "./DesignReview.vue?vue&type=script&lang=js&"
import style0 from "./DesignReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports